import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class PanelTitleService {
  subtitle$ = new BehaviorSubject<string | null>(null);

  setSubtitle(title: string | null): void {
    this.subtitle$.next(title);
  }
}
